import { useEffect } from "react";

// Injects a JSON-LD <script> into <head>, keyed by id, and cleans up on unmount.
export default function JsonLd({ data, id = "jsonld-page" }) {
  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => { const e = document.getElementById(id); if (e) e.remove(); };
  }, [data, id]);
  return null;
}
